import GUI from 'lil-gui';

export type DebugTuning = {
  exposure: number;
  maxDpr: number;
  debugScore: number;
};

export class DebugTools {
  private gui: GUI | null = null;

  constructor(
    tuning: DebugTuning,
    onRendererChange: () => void,
    onScoreChange: (score: number) => void,
  ) {
    const enabled = new URLSearchParams(window.location.search).has('debug');
    if (!enabled) return;

    this.gui = new GUI({ title: '자원순환 마을 튜닝' });
    this.gui.add(tuning, 'exposure', 0.6, 1.8, 0.01).onChange(onRendererChange);
    this.gui.add(tuning, 'maxDpr', 1, 2, 0.25).onChange(onRendererChange);
    this.gui.add(tuning, 'debugScore', 0, 100, 1).name('청정도 미리보기').onChange(onScoreChange);
  }

  dispose(): void {
    this.gui?.destroy();
    this.gui = null;
  }
}
